import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/dcm-2020/dcm-2020.github.io/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Workshop Organizers & Program Committee`}</p>
    </PageDescription>
    <h2>{`Organizers`}</h2>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Jing Mei (IBM Research)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Michiharu Kudo (IBM Research)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Daby Sow (IBM Research)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Atsushi Suzuki (Fujita Health University School of Medicine, Japan)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Edwin Wang (University of Calgary)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Jiao Li (Chinese Academy of Medical Science)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Ping Zhang (The Ohio State University)</AnchorLink>
    </AnchorLinks>
    <h2>{`Program Committee`}</h2>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Jessica Fitts Willoughby (Washington State Univ., USA)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Tiantian He (Nanyang Technological Univ., Singapore)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Zhaomeng Niu (Rutgers Cancer Institute, USA)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Robert Moskovitch (Ben Gurion University, Israel)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Xushen Xiong (MIT CSAIL)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Mingyu Yang (Yale University)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Yixin Chen (Fuwai Hospital, China)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Jingjing Wang (Chinese PLA General Hospital)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Xiang Zhang (Southeast University, China)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Mohamed Ghalwash (IBM Research USA)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Prithwish Chakraborty (IBM Research USA)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Akira Koseki (IBM Research Tokyo)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Takayuki Katsuki (IBM Research Tokyo)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Yiqin Yu (IBM Research China)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Pengwei Hu (IBM Research China)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Zefang Tang (IBM Research China)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Xu Min (IBM Research China)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Yuan Zhang (IBM Research China)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Bibo Hao (IBM Research China)</AnchorLink>
    </AnchorLinks>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      